module.exports = __webpack_public_path__ + "img/yiyao_60_suoluetu.33a211bf.png";